/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateShiftDto } from '../models';
// @ts-ignore
import type { DeleteShiftDto } from '../models';
// @ts-ignore
import type { GetShiftsResponseDto } from '../models';
// @ts-ignore
import type { ShiftResponseDto } from '../models';
// @ts-ignore
import type { UpdateShiftDto } from '../models';
/**
 * EmployeeShiftsApi - axios parameter creator
 * @export
 */
export const EmployeeShiftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new shift
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShift: async (createShiftDto: CreateShiftDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftDto' is not null or undefined
            assertParamExists('createShift', 'createShiftDto', createShiftDto)
            const localVarPath = `/api/v1/employee-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete shift(s) - multiple or bulk by employee
         * @param {DeleteShiftDto} deleteShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShift: async (deleteShiftDto: DeleteShiftDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteShiftDto' is not null or undefined
            assertParamExists('deleteShift', 'deleteShiftDto', deleteShiftDto)
            const localVarPath = `/api/v1/employee-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download employee shifts as an Excel report
         * @param {string} timezone IANA time zone the report times are written in
         * @param {ExportShiftsLanguageEnum} language Report language
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {ExportShiftsShiftStatusEnum} [shiftStatus] Export only shifts with this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportShifts: async (timezone: string, language: ExportShiftsLanguageEnum, businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, shiftStatus?: ExportShiftsShiftStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('exportShifts', 'timezone', timezone)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('exportShifts', 'language', language)
            const localVarPath = `/api/v1/employee-shift/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (shiftStatus !== undefined) {
                localVarQueryParameter['shiftStatus'] = shiftStatus;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get employee shifts with filters
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShifts: async (businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessIds) {
                localVarQueryParameter['businessIds'] = businessIds;
            }

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update shift check-in and check-out times
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShift: async (updateShiftDto: UpdateShiftDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateShiftDto' is not null or undefined
            assertParamExists('updateShift', 'updateShiftDto', updateShiftDto)
            const localVarPath = `/api/v1/employee-shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeShiftsApi - functional programming interface
 * @export
 */
export const EmployeeShiftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeShiftsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new shift
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShift(createShiftDto: CreateShiftDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShift(createShiftDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeShiftsApi.createShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete shift(s) - multiple or bulk by employee
         * @param {DeleteShiftDto} deleteShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShift(deleteShiftDto: DeleteShiftDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShift(deleteShiftDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeShiftsApi.deleteShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download employee shifts as an Excel report
         * @param {string} timezone IANA time zone the report times are written in
         * @param {ExportShiftsLanguageEnum} language Report language
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {ExportShiftsShiftStatusEnum} [shiftStatus] Export only shifts with this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportShifts(timezone: string, language: ExportShiftsLanguageEnum, businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, shiftStatus?: ExportShiftsShiftStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportShifts(timezone, language, businessIds, employeeIds, startDate, endDate, shiftStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeShiftsApi.exportShifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get employee shifts with filters
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShifts(businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShiftsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShifts(businessIds, employeeIds, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeShiftsApi.getShifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update shift check-in and check-out times
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShift(updateShiftDto: UpdateShiftDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShift(updateShiftDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeShiftsApi.updateShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeShiftsApi - factory interface
 * @export
 */
export const EmployeeShiftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeShiftsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new shift
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShift(createShiftDto: CreateShiftDto, options?: RawAxiosRequestConfig): AxiosPromise<ShiftResponseDto> {
            return localVarFp.createShift(createShiftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete shift(s) - multiple or bulk by employee
         * @param {DeleteShiftDto} deleteShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShift(deleteShiftDto: DeleteShiftDto, options?: RawAxiosRequestConfig): AxiosPromise<ShiftResponseDto> {
            return localVarFp.deleteShift(deleteShiftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download employee shifts as an Excel report
         * @param {string} timezone IANA time zone the report times are written in
         * @param {ExportShiftsLanguageEnum} language Report language
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {ExportShiftsShiftStatusEnum} [shiftStatus] Export only shifts with this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportShifts(timezone: string, language: ExportShiftsLanguageEnum, businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, shiftStatus?: ExportShiftsShiftStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportShifts(timezone, language, businessIds, employeeIds, startDate, endDate, shiftStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get employee shifts with filters
         * @param {Array<string>} [businessIds] Filter by business IDs
         * @param {Array<string>} [employeeIds] Filter by employee IDs
         * @param {string} [startDate] Filter shifts from this date (UTC)
         * @param {string} [endDate] Filter shifts until this date (UTC)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShifts(businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetShiftsResponseDto> {
            return localVarFp.getShifts(businessIds, employeeIds, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update shift check-in and check-out times
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShift(updateShiftDto: UpdateShiftDto, options?: RawAxiosRequestConfig): AxiosPromise<ShiftResponseDto> {
            return localVarFp.updateShift(updateShiftDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeShiftsApi - object-oriented interface
 * @export
 * @class EmployeeShiftsApi
 * @extends {BaseAPI}
 */
export class EmployeeShiftsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new shift
     * @param {CreateShiftDto} createShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeShiftsApi
     */
    public createShift(createShiftDto: CreateShiftDto, options?: RawAxiosRequestConfig) {
        return EmployeeShiftsApiFp(this.configuration).createShift(createShiftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete shift(s) - multiple or bulk by employee
     * @param {DeleteShiftDto} deleteShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeShiftsApi
     */
    public deleteShift(deleteShiftDto: DeleteShiftDto, options?: RawAxiosRequestConfig) {
        return EmployeeShiftsApiFp(this.configuration).deleteShift(deleteShiftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download employee shifts as an Excel report
     * @param {string} timezone IANA time zone the report times are written in
     * @param {ExportShiftsLanguageEnum} language Report language
     * @param {Array<string>} [businessIds] Filter by business IDs
     * @param {Array<string>} [employeeIds] Filter by employee IDs
     * @param {string} [startDate] Filter shifts from this date (UTC)
     * @param {string} [endDate] Filter shifts until this date (UTC)
     * @param {ExportShiftsShiftStatusEnum} [shiftStatus] Export only shifts with this status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeShiftsApi
     */
    public exportShifts(timezone: string, language: ExportShiftsLanguageEnum, businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, shiftStatus?: ExportShiftsShiftStatusEnum, options?: RawAxiosRequestConfig) {
        return EmployeeShiftsApiFp(this.configuration).exportShifts(timezone, language, businessIds, employeeIds, startDate, endDate, shiftStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get employee shifts with filters
     * @param {Array<string>} [businessIds] Filter by business IDs
     * @param {Array<string>} [employeeIds] Filter by employee IDs
     * @param {string} [startDate] Filter shifts from this date (UTC)
     * @param {string} [endDate] Filter shifts until this date (UTC)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeShiftsApi
     */
    public getShifts(businessIds?: Array<string>, employeeIds?: Array<string>, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return EmployeeShiftsApiFp(this.configuration).getShifts(businessIds, employeeIds, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update shift check-in and check-out times
     * @param {UpdateShiftDto} updateShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeShiftsApi
     */
    public updateShift(updateShiftDto: UpdateShiftDto, options?: RawAxiosRequestConfig) {
        return EmployeeShiftsApiFp(this.configuration).updateShift(updateShiftDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportShiftsLanguageEnum = {
    fi: 'fi',
    en: 'en'
} as const;
export type ExportShiftsLanguageEnum = typeof ExportShiftsLanguageEnum[keyof typeof ExportShiftsLanguageEnum];
/**
 * @export
 */
export const ExportShiftsShiftStatusEnum = {
    Open: 'Open',
    Closed: 'Closed'
} as const;
export type ExportShiftsShiftStatusEnum = typeof ExportShiftsShiftStatusEnum[keyof typeof ExportShiftsShiftStatusEnum];
